<!--
 * @Author: your name
 * @Date: 2021-07-30 11:24:27
 * @LastEditTime: 2021-11-08 13:18:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /project-logic/component/commonPages/layout/listFormButton.vue
-->
<template>
  <div>
    <Button id="search" type="error" size="small" @click="buttonClick" @keyup.enter="buttonClick" icon="md-search">{{t('查找')}}</Button>
    <Button id="clear" icon="ios-trash-outline" type="default" size="small" @click="buttonClick('clear')">{{t('清空')}}</Button>
    <Button
      id="reset"
      icon="md-refresh"
      type="default"
      size="small"
      @click="buttonClick('reset')"
    >
    {{t('重置')}}
    </Button>
    <!-- 列表其它组件 -->
    <component :is="listOtherComponent" />
  </div>
</template>
<script>
export default {
  name: "ListFormButton",
  props: {
    ButttonCallBack: {
      type: Function,
      default: () => {
        //  点击事件回调
      },
    },
    IconCallBack: {
      type: Function,
      default: () => {
        //  收拉回调
      },
    },
  },
  data() {
    return {
      listOtherComponent: null,
      icon: "ios-arrow-down",
      hiddenButtons: ["reset", "search"], // 隐藏按钮的key
      hiddenIcon: false, // 是否隐藏收拉icon
      isShowBtns: false, // 是否显示按钮组（查询、重置）
    };
  },
  computed: {
    Foldnum:function () {
      return this.$parent.searchFoldnum;
    }
  },
  watch: {
    '$store.state.omsStore.listOtherComponent': {
      handler(val) {
        console.log('listFormButton::listOtherComponent::', val);
        this.listOtherComponent = val;
      },
      deep: true,
      immediate: true,
    },
    Foldnum: {
      handler(newName) {
        // newName-当前设置的行数
        let inputNum = this.$parent.formArray.length;
        let isColumn = this.$parent.setdefaultColumn; // 列数
        this.isShowBtns = (inputNum / isColumn) > newName ? true : false // 产生折叠与否
        if (inputNum % isColumn == 0) {
          // 表单刚好占满
          if (this.isShowBtns) {
            // 有折叠
            $('#listForm').attr('style', 'padding-bottom: 14px !important')
          } else {
            // 没有折叠
            $('#listForm').attr('style', 'padding-bottom: 4px !important')
          }
        } else {
          $('#listForm').attr('style', 'padding-bottom: 14px !important')
        }
    　},
    　immediate: true
    },
    '$parent.dowClass': {
      handler(newVal) {
        // true-打开，反之收起
        const { formArray, setdefaultColumn } = this.$parent;
        if (newVal && formArray.length % setdefaultColumn == 0) {
          // 展开 && 表单刚好占满
          $('#listForm').attr('style', `margin-bottom: ${ newVal ? 20 : 0 }px !important`)
        }
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    buttonClick(type) {
      if (this.$route.params.tableName == 'INVENTORY_MODEL_QUERY') {
        // 【库存模型查询】定制查询接口
        let action = typeof type == 'string' ? type : 'search'
        if (action != 'clear') {
          if (action == 'reset') this.ButttonCallBack('clear'); // 清空表单
          return this.$parent.$parent.$children[1].$children[0].init(action)
        }
      }
      this.ButttonCallBack(type);
    },
    iconClick(e) {
      console.log(this.$parent.searchFoldnum);
      if (
        e.target.className.includes("ios-arrow-down") ||
        (e.target.children.length &&
          e.target.children[0].className.includes("ios-arrow-down"))
      ) {
        this.icon = "ios-arrow-up";
      } else if (
        e.target.className.includes("ios-arrow-up") ||
        (e.target.children.length &&
          e.target.children[0].className.includes("ios-arrow-up"))
      ) {
        this.icon = "ios-arrow-down";
      }
      this.IconCallBack();
    },
  },
};
</script>

<style lang="less">
.standarTableListContent .StandardTableListRootDiv .downComponent-context {
  .tag-close {
    width: 70px;
    height: 14px;
    background: transparent;
    bottom: 0;
    left: 50%;
    top: auto;
    right: auto;
    transform: translateX(-50%);
    i {
      display: inline-block;
      width: 100%;
      height: 100%;
      background: url('~assetsImg/down.png') right no-repeat;
      background-size: 100%;
      transform: rotate(0);
      &::before {
        content: "";
      }
    }
    .icon-xiadown {
      background: url('~assetsImg/up.png') right no-repeat;
    }
  }
}
</style>
